import React from 'react';
import SubmitCommonComponent from './SubmitCommonComponent';
import { SubmitProps } from './utils';

const subheading =
  'You marked at least one item to be sent back to the grantee for further review. We’ll alert them and let you know when it’s time ' +
    'to verify any responses.';

type IncompleteVerificationProps = SubmitProps

const IncompleteVerification: React.FC<IncompleteVerificationProps> = ({
  feedbackType,
  userType,
  isLoading,
  errorMessage,
  onDone,
  className,
  handleBack,
}) => {
  const feedbackIncludesDonor =
    feedbackType === 'Full (TI + Donor)' || feedbackType === 'Donor Only';
  const onClick = () =>
    onDone(
      userType === 'ti staff'
        ? feedbackIncludesDonor
          ? 'Funder Feedback Provided'
          : 'TI Feedback Provided'
        : 'Funder Feedback Provided',
    );
  return (
    <SubmitCommonComponent
      heading="Ready to re-assign to grantee?"
      subheading={subheading}
      buttonText="Send to grantee"
      onClick={onClick}
      isLoading={isLoading}
      errorMessage={errorMessage}
      className={className}
      handleBack={handleBack}
    />
  );
};

export default IncompleteVerification;
